export const temp_url = "https://admin.multitenant.pos.alisonstech-dev.com/Api/api/";
export const base_url = "https://admin.multitenant.pos.alisonstech-dev.com/Api/api/";
export const PathUrl = "https://admin.multitenant.pos.alisonstech-dev.com/Api/api/";



// export const base_url = "http://localhost:8000/api/";
// export const temp_url = "http://localhost:8000/api/";
// export const PathUrl = "http://localhost:8000/";


// export const temp_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const base_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const PathUrl = "http://192.168.18.38/";

// export const temp_url = "http://localhost:8000/api/";
// export const base_url = "http://localhost:8000/api/";
// export const PathUrl = "http://localhost:8000/api/";


// export const temp_url = "http://192.168.18.38/api/";
// export const base_url = "http://192.168.18.38/api/";

// export const temp_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const base_url = 'http://192.168.18.38/property_mangement/v1/api/';
// export const PathUrl = "http://192.168.18.38/";

// export const base_url = "http://192.168.18.227:99/property/public/api/";
// export const temp_url = "http://192.168.18.227:99/property/public/api/";
// export const PathUrl = "http://192.168.18.227:99/property/publc";

export const encryptionSecret = "2d84n0OiymE6eQtvCsdfdstett5zQmm2OsP";

export const feedbackApis = "feedback/store";
export const logInApii = "login";
export const ForgetPassword = "forgot_password/sendCode";
export const ChangePassword = "password/changePassword";
export const VerifyOTP = "forgot_password/verifyCode";
export const registerBrandOwner = "Brand/create";
export const registerRollsApi = "Role/create-role";
export const editRoleAPI = "Role/Update";
export const registerbranduser = "User/register";
export const allUsersApi = "User/get";
export const usersStatusUpdateApi = "User/update";
export const edituserapis = "User/update";
export const assinPreDeatilsss = "AssignFlat/get/";

// <--------------- REPORTS ------------------->

export const allreportApi = "Reports/overAll";
export const reportBynonthapi = "Reports/monthly";
export const reportbypaymentapi = "Reports/payment";
export const reportbyclientapi = "Reports/all/client";
export const reportbypropertyyyapi = "Reports/property";
export const reeportbyyyflatspremieses = "Reports/flat";

// --------------- Dashboard ------------------------->

export const getAllDashboard = "Property/get";
export const NotificationGetAll = "Notifications/get";
export const removeNotification = "Notifications/read";
export const filterpremises = "Flat/get";

// --------------- Dashboard  ------------------------->

// --------------- Permission  ------------------------->


export const allRoleApi = "Role/get-roles";
export const assignpermissionsApi = "Permission/assign-permission";
export const getRolePermissionsApi = "Permission/get-rolepermissions";
export const allpermissionsApi = "Permission/get-allpermissions";


// --------------- Permission  ------------------------->


// <-------------- Users ------------------------->

export const createUsers = "user_management/create";
export const updateUsers = "user_management/update";
export const getAllUsers = "user_management/get";

// <-------------- Users ------------------------->


// <-------------- Tenants ------------------------->
export const createTenants = "tenants";
export const updateTenants = "tenants";
export const getAllTenants = "tenants";
// <-------------- Tenants ------------------------->





// ---------------------------------------------------------------EXTRA---------------------------------------------------------------


// --------------- CLIENT  ------------------------->

export const createCLienApi = "Client/create";
export const fetchgetclientapi = "Client/get";
export const editclinetapi = "Client/update";
export const createfetchassignproperty = "AssignFlat/create";

// --------------- CLIENT  ------------------------->

// <-------------- PAYMENT ------------------------->
export const paymentUniqueId = "AssignFlat/unique/";
export const createPayment = "Payment/create";
export const getPayment = "Payment/get";

// <-------------- PAYMENT ------------------------->
//----------------------------------------------------------------Reports
export const SmsReport = "Report/sms";
export const ReportProblem = "ReportProblem";
export const MapApi = "Report/qr/map";

export const GetAllBatch = "Batches/getAll";
export const postUpdateBatchAPI = "Batches/update";

//---------------------------------------------------------------------------
export const companygetall = "Company/getAll";
export const companystatusupdate = "Company/update";
export const companydetailing = "Company/get";
//---------------------------------------------------------------------------



export const getAllCounts = "Dashboard/get/count";
export const getRandomCodes = "RandomCodes/index";
// ---------------------------------------------------------------EXTRA---------------------------------------------------------------
